import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

const appRoot = document.getElementById('app');
function render() {
  if (!appRoot) return;

  try {
    document.documentElement.setAttribute('data-bs-theme', 'dark');
    document.documentElement.style.backgroundColor = '#000';
    document.documentElement.style.overflow = 'hidden';
    document.body.style.backgroundColor = '#000';
    document.body.style.color = '#fff';
    document.body.style.overflow = 'hidden';
    document.body.style.margin = '0';
  } catch {}

  appRoot.innerHTML = `
    <div class="position-relative min-vh-100 w-100 bg-black text-white overflow-hidden">
      <div class="position-absolute top-0 start-0 w-100 d-flex gap-2 align-items-center p-2" style="z-index: 3;">
        <div class="d-flex gap-2 align-items-center">
          <button id="regenerate" class="btn btn-primary">New</button>
        </div>
        <div class="ms-auto d-flex gap-2 align-items-center">
          <button id="share-btn" class="btn btn-outline-light" title="Share"><i class="bi bi-share"></i></button>
          <button id="download-btn" class="btn btn-outline-light" title="Download"><i class="bi bi-download"></i></button>
        </div>
      </div>
      <div id="tap-hint" class="position-absolute top-50 start-50 translate-middle text-center px-3 py-2 rounded-2" style="z-index: 2; background: rgba(0,0,0,0.35); pointer-events: none;">
        <span class="text-white-50">Tap or click to play</span>
      </div>
      <div id="finished-dim" class="position-absolute top-0 start-0 w-100 h-100 d-none" style="z-index: 1; background: rgba(0,0,0,0.6); display: flex; align-items: center; justify-content: center;">
        <button id="replay-btn" class="btn btn-light rounded-circle p-3" aria-label="Replay" style="opacity: 0.9;">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
            <path d="M11.596 8.697l-6.363 3.692A.75.75 0 0 1 4 11.742V4.258a.75.75 0 0 1 1.233-.647l6.363 3.692a.75.75 0 0 1 0 1.294z"/>
          </svg>
        </button>
      </div>
      <div class="min-vh-100 w-100 d-flex align-items-center justify-content-center">
        <video id="player" playsinline preload="auto" style="width:100%; height:100%; max-width:100vw; max-height:100vh; object-fit: contain; background:#000;"></video>
      </div>
      <pre id="output" class="m-0 p-2 small d-none"></pre>
    </div>
  `;

  const btn = document.getElementById('regenerate');
  const output = document.getElementById('output');
  const statusEl = document.getElementById('status');
  const player = document.getElementById('player');
  const tapHint = document.getElementById('tap-hint');
  const dimOverlay = document.getElementById('finished-dim');
  const replayBtn = document.getElementById('replay-btn');
  const shareBtn = document.getElementById('share-btn');
  const downloadBtn = document.getElementById('download-btn');
  // Track keyboard buffer to detect secret code "xbox"
  let secretBuffer = '';
  // Track current media for share/download without mutating URL
  let currentKey = null;
  let currentBlob = null;
  if (btn && output) {
    const logs = [];
    function appendLog(message) {
      logs.push(String(message));
      if (logs.length > 500) logs.shift();
      output.textContent = logs.join('\n');
    }
    function setStatus(text) {
      if (statusEl) statusEl.textContent = text;
    }

    let isGenerating = false;

    // Ensure a spin animation class for Bootstrap Icons
    try {
      const styleId = 'bi-spin-style';
      if (!document.getElementById(styleId)) {
        const styleEl = document.createElement('style');
        styleEl.id = styleId;
        styleEl.textContent = `@keyframes bi-spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}.bi-spin{animation:bi-spin 1s linear infinite;display:inline-block}`;
        document.head.appendChild(styleEl);
      }
    } catch {}

    function setGeneratingUI(active) {
      try {
        const btnEl = btn;
        if (!btnEl) return;
        if (active) {
          if (!btnEl.dataset.originalHtml) btnEl.dataset.originalHtml = btnEl.innerHTML;
          btnEl.innerHTML = '<i class="bi bi-arrow-repeat bi-spin" aria-hidden="true"></i>';
          btnEl.setAttribute('aria-label', 'Generating…');
          btnEl.disabled = true;
        } else {
          btnEl.disabled = false;
          if (btnEl.dataset.originalHtml != null) {
            btnEl.innerHTML = btnEl.dataset.originalHtml;
          }
          btnEl.removeAttribute('aria-label');
        }
      } catch {}
    }

    function buildApiUrl(ignoreKey = false) {
      const params = new URLSearchParams(window.location.search);
      // ensure we forward xbox mode if present
      if (ignoreKey) params.delete('key');
      const qs = params.toString();
      return `/api/yomama${qs ? `?${qs}` : ''}`;
    }

    async function fetchVideoBlob(ignoreKey = false) {
      const url = buildApiUrl(ignoreKey);
      setStatus('Downloading...');
      appendLog(`Fetching blob from ${url}`);
      const resp = await fetch(url);
      if (!resp.ok) throw new Error(`Failed to fetch video: ${resp.status}`);
      const key = resp.headers.get('x-concat-key');
      const blob = await resp.blob();
      return { blob, key };
    }

    async function generateAndPreload() {
      if (isGenerating) return;
      isGenerating = true;
      output.textContent = 'Requesting /api/yomama (preloading)...';
      setStatus('');
      try {
        setStatus('Downloading (preload)...');
        const { blob, key } = await fetchVideoBlob(false);
        currentBlob = blob;
        if (key) currentKey = key;
        const objectUrl = URL.createObjectURL(blob);
        // Revoke any previous object URL to avoid leaks
        if (player.dataset.currentObjectUrl) {
          try { URL.revokeObjectURL(player.dataset.currentObjectUrl); } catch {}
        }
        player.dataset.currentObjectUrl = objectUrl;
        player.src = objectUrl;
        player.preload = 'auto';
        player.muted = false;
        setStatus('Ready');
        player.addEventListener('ended', () => {
          if (player.dataset.currentObjectUrl) {
            try { URL.revokeObjectURL(player.dataset.currentObjectUrl); } catch {}
            delete player.dataset.currentObjectUrl;
          }
        }, { once: true });
        // Show click-anywhere overlay (if present) after preload so first tap starts audio
        if (clickAnywhere) clickAnywhere.classList.remove('d-none');
        // Ensure dim overlay hidden when ready
        if (dimOverlay) dimOverlay.classList.add('d-none');
      } catch (err) {
        setStatus('Preload failed');
        appendLog(err?.stack || String(err));
      } finally {
        isGenerating = false;
      }
    }

    // First user interaction: click/touch anywhere on document to start playback
    const onFirstUserInteraction = async () => {
      try {
        setStatus('Playing');
        await player.play();
      } catch (e) {
        setStatus('Tap to play');
        appendLog(e?.stack || String(e));
        return;
      }
      if (tapHint) tapHint.classList.add('d-none');
      document.removeEventListener('click', onFirstUserInteraction, true);
      document.removeEventListener('touchstart', onFirstUserInteraction, { capture: true });
    };
    document.addEventListener('click', onFirstUserInteraction, true);
    document.addEventListener('touchstart', onFirstUserInteraction, { capture: true, passive: true });

    // Prevent pausing: auto-resume unless ended
    let suppressAutoResume = false;
    player.addEventListener('pause', () => {
      try {
        if (!suppressAutoResume && !player.ended) {
          player.play().catch(() => {});
        }
      } catch {}
    });

    function replayFromStart() {
      try {
        player.currentTime = 0;
      } catch {}
      setStatus('Playing');
      player.play().catch((e) => {
        appendLog(e?.stack || String(e));
      });
      if (dimOverlay) dimOverlay.classList.add('d-none');
      if (tapHint) tapHint.classList.add('d-none');
    }

    // Dim the page when playback finishes; undim when playing
    player.addEventListener('ended', () => {
      if (dimOverlay) dimOverlay.classList.remove('d-none');
    });
    player.addEventListener('play', () => {
      if (dimOverlay) dimOverlay.classList.add('d-none');
    });

    if (dimOverlay) {
      dimOverlay.addEventListener('click', (ev) => {
        if (ev.target && (ev.target.id === 'replay-btn' || ev.target.closest?.('#replay-btn'))) return;
        replayFromStart();
      });
    }
    if (replayBtn) {
      replayBtn.addEventListener('click', (ev) => {
        ev.stopPropagation();
        replayFromStart();
      });
    }

    btn.addEventListener('click', async () => {
      if (isGenerating) return;
      isGenerating = true;
      setGeneratingUI(true);
      try {
        setStatus('Generating...');
        const { blob, key } = await fetchVideoBlob(true);
        currentBlob = blob;
        if (key) currentKey = key; else currentKey = null;
        const objectUrl = URL.createObjectURL(blob);
        if (player.dataset.currentObjectUrl) {
          try { URL.revokeObjectURL(player.dataset.currentObjectUrl); } catch {}
        }
        player.dataset.currentObjectUrl = objectUrl;
        suppressAutoResume = true;
        player.src = objectUrl;
        player.preload = 'auto';
        player.muted = false;
        setStatus('Playing');
        try { await player.play(); } finally { suppressAutoResume = false; }
        if (tapHint) tapHint.classList.add('d-none');
        // Clear any finish dim on new playback
        if (dimOverlay) dimOverlay.classList.add('d-none');
      } catch (e) {
        setStatus('Failed');
        appendLog(e?.stack || String(e));
      } finally {
        isGenerating = false;
        setGeneratingUI(false);
      }
    });
    // Preload once after page load, do not autoplay
    window.addEventListener('load', () => {
      // Defer slightly to allow UI to settle
      setTimeout(() => { generateAndPreload(); }, 0);
    });

    // Listen for typing 'xbox' anywhere on the page to enable X mode
    document.addEventListener('keydown', async (ev) => {
      try {
        if (ev.key && ev.key.length === 1) {
          secretBuffer += ev.key.toLowerCase();
          if (secretBuffer.length > 8) secretBuffer = secretBuffer.slice(-8);
        } else if (ev.key === 'Backspace') {
          secretBuffer = secretBuffer.slice(0, -1);
        }
        if (secretBuffer.endsWith('xbox')) {
          const url = new URL(window.location.href);
          const alreadyLive = url.searchParams.get('xbox')?.toLowerCase() === 'live';
          if (!alreadyLive) {
            url.searchParams.set('xbox', 'live');
            window.history.replaceState({}, '', url);
            // trigger a fresh fetch honoring xbox=live
            if (!isGenerating) {
              isGenerating = true;
              setStatus('X mode enabled');
              setGeneratingUI(true);
              try {
                const { blob, key } = await fetchVideoBlob(true);
                currentBlob = blob;
                if (key) currentKey = key;
                const objectUrl = URL.createObjectURL(blob);
                if (player.dataset.currentObjectUrl) {
                  try { URL.revokeObjectURL(player.dataset.currentObjectUrl); } catch {}
                }
                player.dataset.currentObjectUrl = objectUrl;
                suppressAutoResume = true;
                player.src = objectUrl;
                player.preload = 'auto';
                player.muted = false;
                setStatus('Playing (X)');
                try { await player.play(); } finally { suppressAutoResume = false; }
                if (tapHint) tapHint.classList.add('d-none');
                if (dimOverlay) dimOverlay.classList.add('d-none');
              } catch (e) {
                setStatus('Failed');
                appendLog(e?.stack || String(e));
              } finally {
                isGenerating = false;
                setGeneratingUI(false);
              }
            }
          }
        }
      } catch {}
    });

    // Share current link (compose without mutating visible URL)
    if (shareBtn) {
      shareBtn.addEventListener('click', async () => {
        try {
          const url = new URL(window.location.href);
          if (currentKey) url.searchParams.set('key', currentKey); else url.searchParams.delete('key');
          const shareUrl = url.toString();
          if (navigator.share) {
            try {
              await navigator.share({ title: document.title || 'Yo Mama Generator', url: shareUrl });
              return;
            } catch {}
          }
          await navigator.clipboard.writeText(shareUrl);
          // brief visual feedback
          const original = shareBtn.innerHTML;
          shareBtn.innerHTML = '<i class="bi bi-clipboard-check"></i>';
          setTimeout(() => { shareBtn.innerHTML = original; }, 1200);
        } catch (e) {
          appendLog(e?.stack || String(e));
        }
      });
    }

    // Download current video
    if (downloadBtn) {
      downloadBtn.addEventListener('click', async () => {
        try {
          let blob = currentBlob;
          if (!blob && player?.src) {
            try {
              const resp = await fetch(player.src);
              if (resp.ok) blob = await resp.blob();
            } catch {}
          }
          if (!blob) return;
          const a = document.createElement('a');
          const dlUrl = URL.createObjectURL(blob);
          a.href = dlUrl;
          a.download = currentKey ? `yomama-${currentKey}.mp4` : `yomama-${Date.now()}.mp4`;
          document.body.appendChild(a);
          a.click();
          setTimeout(() => { try { URL.revokeObjectURL(dlUrl); } catch {}; a.remove(); }, 0);
        } catch (e) {
          appendLog(e?.stack || String(e));
        }
      });
    }
  }
}

render();

if (import.meta && import.meta.webpackHot) {
  import.meta.webpackHot.accept(() => {
    render();
  });
}


